import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const DashboardsDashboard = () => import('@/views/DashboardsDashboard');
const EditDashboard = () => import('@/views/EditDashboard');

const view401 = () => import('@campbell-cloud/vue-cc-security/401.vue');

Vue.use(Router)

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: DefaultContainer,
      meta: {
        translationKey: 'dashboard:nav.home',
        label: 'Home' // fallback label
      },
      children: [
        {
          path: "401",
          name: "401",
          component: view401,
          meta: {
              label: '401'
          }
        },
        {
          path: '/',
          name: 'Dashboards',
          component: DashboardsDashboard,
          meta: {
            security: 'dashboard..entity.read',
            translationKey: 'dashboard:nav.dashboard',
            label: 'Dashboards' // fallback label
          },
        },
        {
          path: '/create',
          name: 'CreateDashboard',
          component: EditDashboard,
          meta: {
            security: 'dashboard..entity.create',
            translationKey: 'dashboard:nav.create',
            label: 'Create' // fallback label
          },
        },
        {
          path: '/edit/:slug',
          name: 'EditDashboard',
          component: EditDashboard,
          meta: {
            security: 'dashboard..entity.read',
            translationKey: 'dashboard:nav.edit',
            label: 'Edit' // fallback label
          },
        },
      ]
    }
  ]
})
